
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      currentMeta: {},
      isAuthRoute: false,
    };
  },

  computed: {
    ...mapGetters({
      config: "CONFIG/CONFIG",
    }),

    getBlockUnwindIsVisible() {
      return this.getBlockIsVisible("unwind");
    },
  },

  watch: {
    $route() {
      this.onRouteChanged();
    },
  },

  methods: {
    onRouteChanged() {
      this.$store.commit("CONFIG/RESET_ALL");
      this.currentMeta = $nuxt.$options.context.route.meta[0];
    },

    getBlockIsVisible(block) {
      if (this.__isLoggedIn) {
        return this.currentMeta?.blocks?.[block]?.dealer;
      } else {
        return this.currentMeta?.blocks?.[block]?.public;
      }
    },
  },

  mounted() {
    this.onRouteChanged();
  },
};
